<app-deal-actions
  [advancedDeal]="advancedDeal"
  [bulkSubmitting]="bulkSubmitting"
  [deal]="deal"
  [dealStatus]="deal?.status"
  [offers]="offers"
  [hasActiveApplication]="hasActiveApplication()"
  [dateSigned]="dateSigned$ | async"
  [loading]="loading"
  [docRequirementsMet]="docRequirementsMet$ | async"
  [questionRequirementsMet]="questionRequirementsMet$ | async"
  [ringingDeal]="ringingDeal"
  (offerReceived)="openOfferDialog()"
  (ringDeal)="openRingDealDialog()"
  (renew)="renewDeal()"
  (sendViaAPI)="sendViaAPI()"
  (reactivate)="openReactivateDealDialog()"
  (send)="sendApplication()">
</app-deal-actions>
